import React from 'react';
import { NavLink } from 'react-router-dom';

import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import Space from 'components/generic/Space.component';
import withSalonId from 'components/hoc/withSalonId.hoc';
import LINK from 'constants/link.const';
import S from 'constants/string.const';
import linkTo from 'utils/links/linkTo.util';

import CN from './AlertAllStylistsOff.module.scss';

const AlertAllStylistsOff = ({ salonId, onClose }) => {
  const calendarSettings = linkTo({
    pattern: LINK.settingsCalendar,
    params: { id: salonId },
    fault: '#',
  });

  return (
    <div data-bem="AlertAllStylistsOff" className={CN.component}>
      <Space>All the team have time off today, select a different day</Space>

      <Space>or use the week view button above to see your columns.</Space>

      <Space>
        If you{S.apos}d rather we didn{S.apos}t hide non-working staff you can change this in
      </Space>

      <Space>
        <NavLink to={calendarSettings}>Settings & Billing {S.arrowE} Calendar Settings</NavLink>
      </Space>
      <div className={CN.closeButton}>
        <Button variant="empty" onClick={onClose}>
          <Icon variant="close" variantInvert />
        </Button>
      </div>
    </div>
  );
};

const AlertAllStylistsOffHoc = withSalonId(AlertAllStylistsOff);

// noinspection JSUnusedGlobalSymbols
export default AlertAllStylistsOffHoc;
